import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import cn from 'classnames';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { IMenuItem } from 'utils/globalTypes';
import { sameParent } from 'utils/urlUtils';

import s from './Navigation.module.scss';

interface INavMenu {
  name: string;
  url: string;
  icon?: string;
  newTab?: boolean;
  transparent: boolean;
  dark: boolean;
  isSticky?: boolean;
  otherUrls?: string[];
  className?: string;
  onAction: (actionName: string, url?: string, newTab?: boolean) => void;
  menuItems?: IMenuItem[];
  isMenuOpen?: boolean;
  setMenuOpen?: (state: boolean) => void;
}

const NavMenu = ({
  name,
  url,
  newTab,
  transparent,
  dark,
  isSticky,
  otherUrls,
  onAction,
  menuItems
}: INavMenu) => {
  const router = useRouter();
  const [anchorEl, setAnchorEl] = useState<HTMLElement>();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (anchorEl) {
      setAnchorEl(undefined);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(undefined);
  };

  const isActive =
    (!newTab && sameParent(router, url)) ||
    (otherUrls && otherUrls?.some((url) => sameParent(router, url)));

  const open = Boolean(anchorEl);

  return (
    <>
      <span
        key={name}
        onClick={handleClick}
        className={cn(s.Navigation__link, 'withIcon', {
          transparent,
          dark,
          isSticky,
          isActive: isActive || open
        })}
      >
        {name}
        <ArrowDropDownIcon />
      </span>
      {menuItems && (
        <Menu
          className={s.Navigation__menu}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          TransitionProps={{ timeout: { enter: 0, exit: 0 } }}
          disableScrollLock
          disableAutoFocusItem
        >
          {menuItems?.map((item, index) => {
            return [
              !!index && <Divider key={`divider-${index}`} />,
              <MenuItem
                key={`item-${index}`}
                className={s.Navigation__menuItem}
                onClick={() => onAction && onAction(item?.name, item?.url, item?.newTab)}
              >
                <ListItemText className={s.Navigation__menuItemText}>{item?.name}</ListItemText>
              </MenuItem>
            ];
          })}
        </Menu>
      )}
    </>
  );
};

export default NavMenu;
